<template>
  <Container>
    <div class="taglist">
      <Tag v-for="tag in tags" :key="tag.id" :tag="tag" />
    </div>
  </Container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import Tag from "@/components/Tag";
import Container from "@/components/Container";

export default {
  name: "taglist",
  components: {
    Tag,
    Container
  },
  computed: {
    ...mapGetters("groups", {
      tags: "listOrdered"
    })
  },
  methods: {
    ...mapActions("groups", ["all"])
  },
  async created() {
    await this.all();
    this.loading = false;
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/css/vars";

.taglist {
  display: grid;

  grid-template-columns: 1fr 1fr 1fr 1fr;

  gap: 3rem;
  @media (max-width: $max-sm) {
    display: none;
  }
}
</style>

<style lang="scss">
.spinner {
  width: initial !important;
  height: initial !important;
  .inner-square {
    border: 0.25rem solid #fa3c3c !important;
  }
}
</style>
